// extracted by mini-css-extract-plugin
module.exports = {"dailyBoostButton":"DailyBoostButton_dailyBoostButton__bx7Ve","dailyTaskCounter":"DailyBoostButton_dailyTaskCounter__12sKX"};